module.exports = __webpack_public_path__ + "static/media/journal2.120513c9.png";